import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Footer from '../components/Footer';

const Life = () => {
  return (
    <>
      <nav aria-label="breadcrumb" className="mt-5 d-flex justify-content-center">
        <ol className="breadcrumb mb-0">
          <li className="breadcrumb-item">
            <a href="/">Home</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Life Insurance
          </li>
        </ol>
      </nav><br />

      {/* Hero Section */}
      <div className="container my-4">
        <div className="row align-items-center g-4">
          <div className="col-lg-6">
            <h1 className="display-5 fw-bold text-primary mb-3">
              Become a Life Insurance Agent
            </h1>
            <p className="lead text-muted mb-4">
              Join India's fastest-growing insurance distribution network
            </p>
            <div className="mb-4">
              <span className="badge bg-primary bg-opacity-10 text-primary px-3 py-2 rounded-pill me-2">
                🚀 49 Lakh+ Workforce
              </span>
              <span className="badge bg-success bg-opacity-10 text-success px-3 py-2 rounded-pill">
                💰 Earn Unlimited Income
              </span>
            </div>
            <p className="mb-3" style={{ textAlign: 'justify', lineHeight: '1.8' }}>
              At <strong>Agency Bazaar</strong>, we connect aspiring insurance professionals with 
              India's leading life insurance companies. A <strong>Life Insurance Agent</strong> is a 
              licensed professional who helps individuals and families choose the right insurance 
              plans to secure their financial future. Agents earn commissions by educating clients 
              and selling suitable policies.
            </p>
          </div>
          <div className="col-lg-6">
            <div className="bg-light rounded-4 p-4 text-center shadow-sm">
              <div className="display-1 mb-3">🛡️</div>
              <h4 className="text-primary">Join as an Insurance Agent</h4>
              <p className="text-muted">Build your career with unlimited earning potential</p>
            </div>
          </div>
        </div>
      </div>

      {/* What is a Life Insurance Agent Section */}
      <div className="container my-5">
        <div className="text-center mb-4">
          <h2 className="fw-bold text-primary">What is a <span className="text-dark">Life Insurance Agent?</span></h2>
          <div className="d-flex justify-content-center">
            <div style={{
              width: '60px',
              height: '3px',
              backgroundColor: '#0d6efd',
              borderRadius: '2px'
            }}></div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-10 mx-auto">
            <div className="p-4 shadow-sm rounded-4 bg-white">
              <p className="mb-3" style={{ fontSize: '1.05rem', lineHeight: '1.8' }}>
                A <strong>Life Insurance Agent</strong> is a <strong>IRDAI-licensed professional</strong> who acts as an intermediary 
                between insurance companies and customers. Their primary role includes:
              </p>
              <ul style={{ fontSize: '1rem', lineHeight: '1.8' }}>
                <li>🎯 Understanding clients' financial goals and protection needs</li>
                <li>📋 Recommending suitable life insurance plans (Term, ULIP, Retirement, Child plans)</li>
                <li>✅ Assisting with application and documentation process</li>
                <li>🤝 Providing ongoing policy servicing and claim support</li>
                <li>📈 Building a client base and earning renewal commissions</li>
              </ul>
              <div className="alert alert-primary mt-3">
                <strong>📊 Industry Opportunity:</strong> India needs <strong>1 Crore (10 Million)</strong> insurance agents by 2047 to achieve "Insurance for All." Currently, there are <strong>49 Lakh+</strong> active agents, creating massive growth potential!
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Benefits of Joining as an Agent */}
      <div className="container my-5">
        <div className="text-center mb-4">
          <h2 className="fw-bold text-primary">Benefits of Joining as <span className="text-dark">Life Insurance Agent</span></h2>
          <div className="d-flex justify-content-center">
            <div style={{
              width: '60px',
              height: '3px',
              backgroundColor: '#0d6efd',
              borderRadius: '2px'
            }}></div>
          </div>
          <p className="text-muted mt-3">Why thousands choose insurance as their career</p>
        </div>

        <div className="row g-4">
          <div className="col-md-6 col-lg-4">
            <div className="p-4 shadow-sm rounded-4 h-100 bg-white"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
                style={{ transition: 'all 0.3s ease' }}>
              <div className="fs-1 mb-3">💰</div>
              <h5 className="fw-bold">Unlimited Earning Potential</h5>
              <p className="text-muted">Earn 15-35% commission on every policy sold + renewal commissions for years. No income ceiling!</p>
              <small className="text-primary">First-year commissions up to 40%</small>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="p-4 shadow-sm rounded-4 h-100 bg-white"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
                style={{ transition: 'all 0.3s ease' }}>
              <div className="fs-1 mb-3">⏰</div>
              <h5 className="fw-bold">Flexible Work Hours</h5>
              <p className="text-muted">Be your own boss! Work part-time or full-time. Perfect for students, homemakers, and retired professionals.</p>
              <small className="text-primary">Work from anywhere, anytime</small>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="p-4 shadow-sm rounded-4 h-100 bg-white"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
                style={{ transition: 'all 0.3s ease' }}>
              <div className="fs-1 mb-3">🏆</div>
              <h5 className="fw-bold">Incentives & Rewards</h5>
              <p className="text-muted">Foreign trips, bonuses, awards, and recognition from top insurance companies.</p>
              <small className="text-primary">Achievement-based rewards</small>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="p-4 shadow-sm rounded-4 h-100 bg-white"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
                style={{ transition: 'all 0.3s ease' }}>
              <div className="fs-1 mb-3">📚</div>
              <h5 className="fw-bold">Free Training & Certification</h5>
              <p className="text-muted">IRDAI-approved training, licensing support, and continuous learning programs at no cost.</p>
              <small className="text-primary">Become IRDAI certified</small>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="p-4 shadow-sm rounded-4 h-100 bg-white"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
                style={{ transition: 'all 0.3s ease' }}>
              <div className="fs-1 mb-3">🤝</div>
              <h5 className="fw-bold">Passive Income</h5>
              <p className="text-muted">Earn renewal commissions for 5+ years on every policy sold. Build long-term wealth!</p>
              <small className="text-primary">Renewal income for years</small>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="p-4 shadow-sm rounded-4 h-100 bg-white"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
                style={{ transition: 'all 0.3s ease' }}>
              <div className="fs-1 mb-3">👩</div>
              <h5 className="fw-bold">Women Empowerment</h5>
              <p className="text-muted">Special initiatives like Bima Sakhi Yojana encouraging women to join insurance workforce.</p>
              <small className="text-primary">30% agents are women</small>
            </div>
          </div>
        </div>
      </div>

      {/* How to Work as Life Insurance Agent */}
      <div className="container my-5">
        <div className="text-center mb-4">
          <h2 className="fw-bold text-primary">How to Work as <span className="text-dark">Life Insurance Agent</span></h2>
          <div className="d-flex justify-content-center">
            <div style={{
              width: '60px',
              height: '3px',
              backgroundColor: '#0d6efd',
              borderRadius: '2px'
            }}></div>
          </div>
          <p className="text-muted mt-3">Simple 5-step process to start your insurance career</p>
        </div>

        <div className="row g-4">
          <div className="col-md-6 col-lg-4">
            <div className="p-4 shadow-sm rounded-4 h-100 bg-white text-center">
              <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3" 
                   style={{ width: '60px', height: '60px', fontSize: '24px', fontWeight: 'bold' }}>
                1
              </div>
              <h5 className="fw-bold">Complete IRDAI Training</h5>
              <p className="text-muted">Enroll in 50-hour compulsory training from an IRDAI-approved institute (online/offline).</p>
              <small className="text-primary">Duration: 2-3 weeks</small>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="p-4 shadow-sm rounded-4 h-100 bg-white text-center">
              <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3" 
                   style={{ width: '60px', height: '60px', fontSize: '24px', fontWeight: 'bold' }}>
                2
              </div>
              <h5 className="fw-bold">Pass Licensing Exam</h5>
              <p className="text-muted">Clear IRDAI's IC-38 examination to get your agent license. We provide full support!</p>
              <small className="text-primary">Exam conducted online</small>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="p-4 shadow-sm rounded-4 h-100 bg-white text-center">
              <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3" 
                   style={{ width: '60px', height: '60px', fontSize: '24px', fontWeight: 'bold' }}>
                3
              </div>
              <h5 className="fw-bold">Get Appointed with Insurers</h5>
              <p className="text-muted">Agency Bazaar connects you with 20+ top life insurance companies for appointment.</p>
              <small className="text-primary">Multiple insurer options</small>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="p-4 shadow-sm rounded-4 h-100 bg-white text-center">
              <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3" 
                   style={{ width: '60px', height: '60px', fontSize: '24px', fontWeight: 'bold' }}>
                4
              </div>
              <h5 className="fw-bold">Build Client Network</h5>
              <p className="text-muted">Start with family & friends. Use referrals, social media, and local community to find clients.</p>
              <small className="text-primary">Unlimited earning potential</small>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="p-4 shadow-sm rounded-4 h-100 bg-white text-center">
              <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3" 
                   style={{ width: '60px', height: '60px', fontSize: '24px', fontWeight: 'bold' }}>
                5
              </div>
              <h5 className="fw-bold">Earn & Grow</h5>
              <p className="text-muted">Earn commissions, renewals, bonuses. Get promoted to Development Officer or Branch Manager.</p>
              <small className="text-primary">Career growth path</small>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="p-4 shadow-sm rounded-4 h-100 bg-white text-center">
              <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3" 
                   style={{ width: '60px', height: '60px', fontSize: '24px', fontWeight: 'bold' }}>
                💡
              </div>
              <h5 className="fw-bold">Daily Work Activities</h5>
              <p className="text-muted">• Client meetings (10-15 daily)<br/>• Need analysis & planning<br/>• Policy follow-ups<br/>• Claim assistance</p>
              <small className="text-primary">Flexible schedule</small>
            </div>
          </div>
        </div>
      </div>

      {/* Types of Life Insurance Plans Agents Sell */}
      <div className="container my-5">
        <div className="text-center mb-4">
          <h2 className="fw-bold text-primary">Life Insurance Plans <span className="text-dark">You'll Sell as an Agent</span></h2>
          <div className="d-flex justify-content-center">
            <div style={{
              width: '60px',
              height: '3px',
              backgroundColor: '#0d6efd',
              borderRadius: '2px'
            }}></div>
          </div>
        </div>

        <div className="row g-4">
          <div className="col-md-6 col-lg-3">
            <div className="card border-0 shadow-sm h-100 text-center"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.12)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
                style={{ transition: 'all 0.3s ease' }}>
              <div className="card-body">
                <div className="fs-1 mb-2">📋</div>
                <h5 className="card-title fw-bold">Term Insurance</h5>
                <p className="card-text text-muted small">High coverage at affordable premiums. High demand product with good commissions.</p>
                <small className="text-primary">Commission: 15-35%</small>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-3">
            <div className="card border-0 shadow-sm h-100 text-center"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.12)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
                style={{ transition: 'all 0.3s ease' }}>
              <div className="card-body">
                <div className="fs-1 mb-2">💰</div>
                <h5 className="card-title fw-bold">ULIP Plans</h5>
                <p className="card-text text-muted small">Investment + Insurance. Appeals to young professionals.</p>
                <small className="text-primary">Market-linked returns</small>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-3">
            <div className="card border-0 shadow-sm h-100 text-center"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.12)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
                style={{ transition: 'all 0.3s ease' }}>
              <div className="card-body">
                <div className="fs-1 mb-2">🏦</div>
                <h5 className="card-title fw-bold">Retirement Plans</h5>
                <p className="card-text text-muted small">Secure golden years with regular pension. Growing market.</p>
                <small className="text-primary">Annuity products</small>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-3">
            <div className="card border-0 shadow-sm h-100 text-center"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.12)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
                style={{ transition: 'all 0.3s ease' }}>
              <div className="card-body">
                <div className="fs-1 mb-2">👨‍👩‍👧‍👦</div>
                <h5 className="card-title fw-bold">Child Plans</h5>
                <p className="card-text text-muted small">Secure children's future education. Emotional selling works well.</p>
                <small className="text-primary">High closure rate</small>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Skills Required for Success */}
      <div className="container my-5">
        <div className="bg-light rounded-4 p-5">
          <div className="text-center mb-4">
            <h2 className="fw-bold text-primary">Skills Required to Succeed</h2>
            <div className="d-flex justify-content-center">
              <div style={{
                width: '60px',
                height: '3px',
                backgroundColor: '#0d6efd',
                borderRadius: '2px'
              }}></div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <ul className="list-unstyled">
                <li className="mb-3">✅ <strong>Communication Skills</strong> - Explain complex products simply</li>
                <li className="mb-3">✅ <strong>Networking Ability</strong> - Build and maintain client relationships</li>
                <li className="mb-3">✅ <strong>Persuasion & Negotiation</strong> - Close deals effectively</li>
                <li className="mb-3">✅ <strong>Basic Financial Knowledge</strong> - Understand insurance and investments</li>
              </ul>
            </div>
            <div className="col-md-6">
              <ul className="list-unstyled">
                <li className="mb-3">✅ <strong>Empathy & Patience</strong> - Understand client needs genuinely</li>
                <li className="mb-3">✅ <strong>Self-Motivation</strong> - Work independently without supervision</li>
                <li className="mb-3">✅ <strong>Digital Literacy</strong> - Use apps, social media, and online tools</li>
                <li className="mb-3">✅ <strong>Problem-Solving</strong> - Help clients with claims and issues</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="container my-5">
        <div className="bg-primary text-white rounded-4 p-5 text-center"
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.02)';
              e.currentTarget.style.transition = 'all 0.3s ease';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
            }}>
          <h2 className="fw-bold mb-3">Ready to Start Your Career as Insurance Agent?</h2>
          <p className="mb-4">Join Agency Bazaar today! Get free training, licensing support, and appointment with top insurers.</p>
          <button
            className="btn btn-light btn-lg px-5 rounded-pill text-primary fw-bold"
            style={{ transition: 'all 0.3s ease' }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.backgroundColor = '#f8f9fa';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
            }}
          >
            Register as an Agent Now →
          </button>
          <p className="mt-3 small opacity-75">Limited slots available. Apply today!</p>
        </div>
      </div>

      <Footer />
    </>
  )
}

export default Life;


